import {
  AmountRateResponseDTO,
  ExchangeCalculateRequestDTO,
  IExchangeCalculateRepository,
  IExchangeCalculatorService,
} from '../entities';

export class ExchangeCalculateServiceImpl implements IExchangeCalculatorService {
  itemRepo: IExchangeCalculateRepository;

  constructor(ir: IExchangeCalculateRepository) {
    this.itemRepo = ir;

    this.PostExchangeCalculate = this.PostExchangeCalculate.bind(this);
  }

  PostExchangeCalculate(params: { data: ExchangeCalculateRequestDTO }): Promise<AmountRateResponseDTO> {
    return this.itemRepo.PostExchangeCalculate(params.data);
  }
}
